<template>
    <div class="text-center m-t-10">
        {{ trans('global.or') }}
        <a @click.prevent="openModal" class="pointer">
            {{  trans('global.unsplash_link') }}
        </a>
    </div>
</template>

<script>
export default {
    props: {
        query: {
            type: String,
            default: 'events',
        },

        unsplashUploadType: {
            type: String,
            default: 'sync'
        },
    },

    methods: {
        openModal () {
            $('#unsplash-modal').modal('show');
            this.$event_bus.$emit('unsplashUploadType', this.unsplashUploadType);
            if (this.query) {
                this.$event_bus.$emit('unsplashSearchQuery', this.query);
            }
        },
    }
}
</script>
